import { render, staticRenderFns } from "./ContactAppointments.vue?vue&type=template&id=b18ce07c&scoped=true"
import script from "./ContactAppointments.vue?vue&type=script&lang=js"
export * from "./ContactAppointments.vue?vue&type=script&lang=js"
import style0 from "./ContactAppointments.vue?vue&type=style&index=0&id=b18ce07c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18ce07c",
  null
  
)

export default component.exports